import React, { createContext, useContext, useMemo, useState } from 'react';

interface HighlightedTraceContextType {
  highlightedTraceId: string | null;
  setHighlightedTraceId: (traceId: string | null) => void;
}

const HighlightedTraceContext = createContext<HighlightedTraceContextType>({
  highlightedTraceId: null,
  setHighlightedTraceId: () => {},
});

export const useHighlightedTrace = () => useContext(HighlightedTraceContext);

export const HighlightedTraceProvider: React.FC = ({ children }) => {
  const [highlightedTraceId, setHighlightedTraceId] = useState<string | null>(null);
  const value = useMemo(
    () => ({ highlightedTraceId, setHighlightedTraceId }),
    [highlightedTraceId, setHighlightedTraceId],
  );
  return (
    <HighlightedTraceContext.Provider value={value}>
      {children}
    </HighlightedTraceContext.Provider>
  );
};
